import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicLayout } from '../../components/PublicLayout';
import { publicAPI } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import {
  Search,
  Loader2,
} from 'lucide-react';
import { toast } from 'sonner';

export default function BookingLookup() {
  const navigate = useNavigate();
  const [reference, setReference] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!reference.trim()) {
      toast.error('Please enter a booking reference');
      return;
    }

    setLoading(true);
    try {
      await publicAPI.getBookingByReference(reference.trim().toUpperCase());
      navigate(`/booking/confirmation/${reference.trim().toUpperCase()}`);
    } catch (error) {
      toast.error('Booking not found. Please check your reference number.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <div className="py-24" data-testid="booking-lookup-page">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-serif font-medium mb-4">Find Your Booking</h1>
            <p className="text-muted-foreground">
              Enter your booking reference to view your reservation details.
            </p>
          </div>

          <Card>
            <CardContent className="p-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="reference">Booking Reference</Label>
                  <Input
                    id="reference"
                    placeholder="e.g. HB12345678"
                    value={reference}
                    onChange={(e) => setReference(e.target.value.toUpperCase())}
                    className="text-center font-mono text-lg tracking-wider"
                    data-testid="reference-input"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={loading}
                  data-testid="lookup-btn"
                >
                  {loading ? (
                    <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  ) : (
                    <Search className="h-4 w-4 mr-2" />
                  )}
                  Find Booking
                </Button>
              </form>
            </CardContent>
          </Card>

          <p className="text-center text-sm text-muted-foreground mt-6">
            Your booking reference was sent to your email upon confirmation.
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}
